import React, {Component} from 'react'

export class Form extends Component {
    constructor(props) {
        super(props);

        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this._processChildren = this._processChildren.bind(this);

        this.setErrors = this.setErrors.bind(this);

        this.state = {
            generalError: undefined
        };

        this._errors = {};
    }

    onSubmitHandler(event, onSubmit) {
        event.preventDefault();

        this.cleanErrors();

        let formData = getFormData(this.formElement);

        if (typeof onSubmit === 'function') {
            onSubmit(formData, this.setErrors)
        }
    }

    _processChildren(element) {
        if (!React.isValidElement(element)) return element;

        let props = {};

        let errors = this._errors;

        if (typeof element.type === 'function') {
            // handling field wrappers
            if(element.props['data-formfield'] === true) {
                if (errors[element.props.name]) {
                    props = {
                        ...props,
                        errors: [ errors[element.props.name] ]
                    };
                }
            }

            // handling error containers
            if (element.props['data-errorcontainer'] === true) {
                props = {
                    ...props,
                    error: this.state.generalError
                };
            }
        }

        let children = React.Children.map(element.props.children, this._processChildren);

        return React.cloneElement(element, props, children);
    }

    cleanErrors() {
        this._errors = {};
        this.setState({generalError: undefined});
    }

    /**
     * @param errors
     * @param single Pass only single, the first error.
     */
    setErrors(errors, single = false) {
        if (typeof errors == 'object') {
            if (single) {
                for (let field in errors) {
                    if (!errors[field].length) continue;
                    this._errors = {...this._errors, ...{[field]: errors[field][0]}};
                    break;
                }
            } else {
                this._errors = {...this._errors, ...errors};
            }

            this.forceUpdate();
        } else {
            this.setState({generalError: errors})
        }
    }

    render() {
        let {onSubmit, children, ...rest} = this.props;
        children = React.Children.map(children, this._processChildren);

        return (
            <form
                onSubmit={(event) => this.onSubmitHandler(event, onSubmit)}
                ref={(ref) => this.formElement = ref}
                {...rest}
            >
                {children}
            </form>
        )
    }
}

function FormField(field, props) {
    let {errors, children, forceHtml = false, ...rest} = props,
        errorsPresent = errors && errors.length;

    let classNames = ['input-wrapper'];

    let errorBlock = null;
    if (errorsPresent) {
        classNames.push('error');
        errorBlock = forceHtml ? <p dangerouslySetInnerHTML={{__html: errors[0]}}/> : <p>{errors[0]}</p>;
    }

    return (
        <div className={classNames.join(' ')}>
            {errorBlock}
            {React.createElement(field, rest, children)}
        </div>
    )
}

export function InputWrapper(props) { return FormField('input', props) }
export function SelectWrapper(props) { return FormField('select', props) }
export function TextareaWrapper(props) { return FormField('textarea', props) }

export function ErrorContainer({error, allowHtml = false}) {
    // todo: return null in a case of empty error?
    if (!error) return null;

    return (
        <div className="error">
            {allowHtml ? <p dangerouslySetInnerHTML={{__html: error}}/> : <p>{error}</p>}
        </div>
    )
}

/**
 * @param form
 * @param {object} [options]
 * @param {string} [options.inputSelector] XPath/CSS selector for input elements inside form to be handled
 * @param {boolean} [options.skipEmpty] Skip inputs with empty values
 * @return {object}
 */
function getFormData(form, options = {}) {
    const defaultGetFormDataOptions = {
        inputSelector: "input, textarea, select",
        skipEmpty: false
    };

    options = {
        ...defaultGetFormDataOptions,
        ...options
    };

    let inputs = form.querySelectorAll(options.inputSelector);

    let data = {};

    for (let input of inputs) {
        if (input.type === "checkbox" || input.type === "radio") {
            if (input.checked) data[input.name] = input.value;
            continue;
        }

        if (options.skipEmpty && input.value === "" || input.value === undefined) continue;

        data[input.name] = input.value;
    }

    return data;
}


// WEBPACK FOOTER //
// ./local_modules/form/index.js